import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=79e65293&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vincent/Documents/Développement/Stadia Fr/Jeux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79e65293')) {
      api.createRecord('79e65293', component.options)
    } else {
      api.reload('79e65293', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=79e65293&", function () {
      api.rerender('79e65293', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/javascripts/components/Footer.vue"
export default component.exports